export default __webpack_public_path__ + "static/media/resume.082d06e2.svg";